import React, { Component } from 'react';
import './CustomCheckSelector.css'
import {injectIntl} from "react-intl";
import { addItemSelect, removeItemSelect } from "../../actions/MultiselectAction";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class CustomCheckSelector extends Component {
  handleSelectItem = (e) => {
    e.stopPropagation();
    const { addItemSelect, removeItemSelect, itemHover, keyCollection, selectedFiles } = this.props;
    const isSelected = selectedFiles.some(x => x._id === itemHover._id);
    if (!isSelected) {
      addItemSelect(itemHover, keyCollection);
    } else {
      removeItemSelect(itemHover, keyCollection);
    }
  }

  render() {
    const {
      isHover,
      k,
      indice,
      selectedFiles,
      itemHover,
      from,
      inList,
      folderOrBunker,
      newColor
    } = this.props;

    const isSelected = selectedFiles.some(x => x._id === itemHover._id);

    if ((isHover && `${from}-${k}` === indice) || isSelected) return (
      <div
        onMouseEnter={this.props.handleOnMouseEnter}
        onMouseLeave={this.props.handleOnMouseLeave}
      >
        <div 
          className={`custom-select ${isSelected ? "open" : ""}`} 
          onClick={this.handleSelectItem}
          style = {{
            top: inList ? "12px" : "5px",
            borderWidth: "3px",
            borderStyle: "solid",
            borderColor: folderOrBunker ? "white": newColor
          }}
        >
          
          </div>
      </div>
    )
    else return null;
  }
}

const mapStateToProps = (state) => {
  return {
    selectedFiles: state.selectedFiles.data,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  }
}

const mapDispatchToProps = {
  addItemSelect,
  removeItemSelect,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomCheckSelector)))
